<template>
  <el-row>
    <!-- 搜索项结构  v-if="filter(item.field)" -->
    <el-col
      v-for="(item, index) in options"
      :key="index"
      :xs="item.column[0]"
      :sm="item.column[1]"
      :md="item.column[2]"
      :lg="item.column[3]"
      v-if="filter(item.visible)">
      <el-form-item :label="item.label" :prop="item.prop">
        <!-- 输入框 -->
        <el-input
          v-if="item.component === 'input'"
          v-model="optionData[item.field]"
          :placeholder="item.placeholder"
          :title="item.placeholder"
          :size="size"
          :type="item.type || 'text'"
          :disabled="item.disabled || false"
          :class="item.field"/>
        <!-- 文本框 -->
        <el-input
          type="textarea"
          :rows="item.rows"
          v-if="item.component === 'textarea'"
          v-model="optionData[item.field]"
          :placeholder="item.placeholder"
          :title="item.placeholder"
          :size="size"
          :class="item.field"/>
        <!-- 普通常量下拉 -->
        <el-select
          v-if="item.component === 'select'"
          v-model="optionData[item.field]"
          :multiple="item.multiple"
          :placeholder="item.placeholder"
          :title="item.placeholder"
          :size="size"
          :clearable="item.clearable"
          filterable>
          <el-option
            v-for="v in constDict[item.constKey]"
            :key="v.value"
            :label="v.label"
            :value="v.value"/>
        </el-select>
        <!-- 分组常量下拉 -->
        <el-select
          v-if="item.component === 'mgSelect'"
          class="mgSelect"
          v-model="optionData[item.field]"
          :multiple="item.multiple"
          :placeholder="item.placeholder"
          :title="item.placeholder"
          :size="size"
          :clearable="item.clearable"
          filterable>
          <el-option-group
            v-for="(group, index) in constDict[item.constKey]"
            :key="index"
            :label="group.label">
            <el-option
              v-for="v in group.options"
              :key="v.value"
              :label="v.label"
              :value="v.value"/>
          </el-option-group>
        </el-select>
        <!-- 国家筛选常量下拉 -->
        <el-select
          v-if="item.component === 'CountrySelect'"
          v-model="optionData[item.field]"
          :placeholder="item.placeholder"
          :title="item.placeholder"
          :size="size"
          :clearable="item.clearable"
          filterable>
          <el-option
            v-for="option in constDict[item.constKey]"
            v-if="option.country === optionData.country_id"
            :key="option.userid"
            :label="option.truename"
            :value="option.userid"/>
        </el-select>
        <el-date-picker
          v-if="item.component === 'time'"
          v-model="optionData[item.field]"
          :type="item.type ? item.type : 'date'"
          placeholder="选择日期"
          :title="item.placeholder"
          :size="size"
          :clearable="item.clearable"
          :value-format="item.valueFormat ? item.valueFormat:'yyyy-MM-dd'"
          :format="item.format ?item.format :'yyyy-MM-dd'"
          filterable/>
        <!-- 时间范围 -->
        <el-date-picker
          v-if="item.component === 'timeline'"
          v-model="optionData[item.field]"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :title="item.placeholder"
          type="daterange"
          :picker-options="item.pickerOptions || pickerOptions"
          :size="size"
          :clearable="item.clearable"
          filterable/>
        <!-- 字典项下拉 -->
        <jm-dict-select
          v-if="item.component === 'dict'"
          v-model="optionData[item.field]"
          :placeholder="item.placeholder"
          :title="item.placeholder"
          :type="item.type"
          :dict-type="item.dict"
          :name="item.name || ''"
          :size="size"
          :clearable="item.clearable"
          filterable/>
        <!-- 二级字典项下拉 -->
        <jm-dict-select
          v-if="item.component === 'secendDict'"
          v-model="optionData[item.field]"
          :placeholder="item.placeholder"
          :title="item.placeholder"
          :type="item.type"
          :dict-type="item.dict"
          :filter="opt => opt.pid === optionData[item.filter]"
          :size="size"
          :clearable="item.clearable"
          filterable/>
        <!-- 国家筛选字典项下拉 -->
        <jm-dict-select
          v-if="item.component === 'countryDict'"
          v-model="optionData[item.field]"
          :placeholder="item.placeholder"
          :title="item.placeholder"
          :type="item.type"
          :dict-type="item.dict"
          :filter="opt => $inCountry(opt.id)"
          :size="size"
          :clearable="item.clearable"
          filterable/>

      </el-form-item>
    </el-col>
    <!-- /搜索项结构 -->
  </el-row>
</template>
<script type="text/javascript">
import { jmDictSelect } from '@/components/tool';
import { filterVisible } from '@/utils/utils';


// picker选项
const pickerOptions = {
  disabledDate(time) {
    return time.getTime() > Date.now();
  },
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - (3600 * 1000 * 24 * 7));
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - (3600 * 1000 * 24 * 30));
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近三个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - (3600 * 1000 * 24 * 90));
        picker.$emit('pick', [start, end]);
      }
    }
  ]
};
export default {
  data() {
    return {
      pickerOptions
    };
  },
  props: {
    // 默认搜索项为空
    options: {
      type: Array,
      default: function() {
        return [];
      }
    },
    // 默认不过滤字段（搜索表单展示搜索项时过滤）
    needFilter: {
      type: Boolean, default: false
    },
    // 表单样式
    size: {
      type: String, default: ''
    },
    // 表单值
    optionData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    // 常量字典 or 特殊字典
    constDict: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: { jmDictSelect },
  methods: {
    filter(visible) {
      if (this.needFilter) {
        return filterVisible(visible);
      }
      return true;
    }
  }
};
</script>
<style type="text/css" scoped>
.mgSelect.el-select {
  display: block;
}
</style>
